import {
  required,
  numeric,
  between,
} from 'vuelidate/lib/validators';
import parametersFields
  from '@/domain/data/installation/engineering/finalGradient/parametersFields';

const alarmTemperatureReachTime = parameters => ({
  required,
  numeric,
  between: between(
    parametersFields(parameters).alarmTemperatureReachTime.minValue,
    parametersFields(parameters).alarmTemperatureReachTime.maxValue,
  ),
  multiple: parametersFields(parameters).alarmTemperatureReachTime.isMultiple,
});

const shutdownTemperatureReachTime = parameters => ({
  required,
  numeric,
  between: between(
    parametersFields(parameters).shutdownTemperatureReachTime.minValue,
    parametersFields(parameters).shutdownTemperatureReachTime.maxValue,
  ),
  multiple: parametersFields(parameters).shutdownTemperatureReachTime.isMultiple,
});

export default parameters => ({
  parameters: {
    alarmTemperatureReachTime: alarmTemperatureReachTime(parameters),
    shutdownTemperatureReachTime: shutdownTemperatureReachTime(parameters),
  },
});
